import React from "react";
import { Trans, useTranslation } from "react-i18next";
import PageHeader from "components/common/PageHeader";
import { ExternalLink } from "components/common";
import EmbeddedCloudTrailApp from "./EmbeddedCloudTrailApp";
const CloudTrailApp = () => {
  const { t } = useTranslation("integrations");
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(PageHeader, { title: t("aws_cloudtrail_app.title") }, /* @__PURE__ */ React.createElement("span", null, t("aws_cloudtrail_app.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "aws_cloudtrail_app.requirement",
      components: {
        cloudTrailLink: /* @__PURE__ */ React.createElement(ExternalLink, { href: "https://aws.amazon.com/console/" })
      }
    }
  ))), /* @__PURE__ */ React.createElement(EmbeddedCloudTrailApp, null));
};
export default CloudTrailApp;
